module.exports = __webpack_public_path__ + "img/img7.aef2306f.png";